import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchGames(ctx, params) {
      return axios.get('/fnf-league/games', { params })
    },
    syncGames(ctx, { season }) {
      return axios.post('/fnf-league/sync', { season })
    },
    createChat(ctx, gameId) {
      return axios.post(`/fnf-league/games/${gameId}/chat`)
    },
    // Точечный синк одной игры (результаты тянутся принудительно) — не гоняет весь сезон
    syncGame(ctx, gameId) {
      return axios.post(`/fnf-league/games/${gameId}/sync`)
    },
    fetchStandings(ctx, params) {
      return axios.get('/fnf-league/standings', { params })
    },
    fetchHostSlots() {
      return axios.get('/fnf-league/host-slots')
    },
    importHostSlots(ctx, text) {
      return axios.post('/fnf-league/host-slots/import', { text })
    },
    deleteHostSlot(ctx, slotId) {
      return axios.delete(`/fnf-league/host-slots/${slotId}`)
    },
    assignHostSlot(ctx, { gameId, slotId }) {
      return axios.post(`/fnf-league/games/${gameId}/assign-slot`, { slot_id: slotId })
    },
  },
}
